import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=a12b8c6a&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=a12b8c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12b8c6a",
  null
  
)

export default component.exports